/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AgentZoneVO} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';

@Injectable({
  providedIn: 'root'
})
export class AgentZoneVoResourceService extends SelectableResourceService<AgentZoneVO> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('agentZoneUrl'),
      AgentZoneVO
    );
  }
}
